import React, { useState } from 'react';
import { Button } from '@/components/ui/button';
import { Label } from '@/components/ui/label';
import { Textarea } from '@/components/ui/textarea';
import { Loader2, Plus, X } from 'lucide-react';

// Notes Tab — quick free-text remarks attached to the export. Owns its own
// "compose" state; mutations bubble up to the parent via callbacks.
export const NotesTab = ({ notes, onAddNote, onDeleteNote, formatDateTime }) => {
  const [newNote, setNewNote] = useState('');
  const [saving, setSaving] = useState(false);

  const handleAdd = async () => {
    if (!newNote.trim()) return;
    setSaving(true);
    try {
      await onAddNote(newNote);
      setNewNote('');
    } finally {
      setSaving(false);
    }
  };

  return (
    <div className="space-y-4">
      <div className="space-y-2">
        <Label className="text-slate-300">Remarks</Label>
        <Textarea
          value={newNote}
          onChange={(e) => setNewNote(e.target.value)}
          placeholder="Add a note..."
          className="bg-slate-950 border-slate-700 text-white min-h-[80px]"
        />
        <Button
          size="sm"
          onClick={handleAdd}
          disabled={saving || !newNote.trim()}
          className="bg-blue-600 hover:bg-blue-500"
        >
          {saving ? <Loader2 className="h-4 w-4 animate-spin mr-1" /> : <Plus className="h-4 w-4 mr-1" />}
          Add Note
        </Button>
      </div>
      <div className="space-y-2 max-h-[300px] overflow-y-auto">
        {notes.map(note => (
          <div key={note.id} className="bg-slate-950 border border-slate-800 rounded-lg p-3">
            <div className="flex items-start justify-between">
              <div className="flex-1">
                <p className="text-white whitespace-pre-wrap">{note.content}</p>
                <p className="text-xs text-slate-500 mt-2">
                  {note.created_by_name || 'Unknown'} • {formatDateTime(note.created_at)}
                </p>
              </div>
              <Button
                variant="ghost"
                size="sm"
                onClick={() => onDeleteNote(note.id)}
                className="h-6 w-6 p-0 text-red-400"
              >
                <X className="h-3 w-3" />
              </Button>
            </div>
          </div>
        ))}
        {notes.length === 0 && <p className="text-slate-500 text-center py-4">No notes yet</p>}
      </div>
    </div>
  );
};
